import { render, staticRenderFns } from "./SidebarExtraFieldsBlock.vue?vue&type=template&id=a541a950&scoped=true"
import script from "./SidebarExtraFieldsBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarExtraFieldsBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarExtraFieldsBlock.vue?vue&type=style&index=0&id=a541a950&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a541a950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a541a950')) {
      api.createRecord('a541a950', component.options)
    } else {
      api.reload('a541a950', component.options)
    }
    module.hot.accept("./SidebarExtraFieldsBlock.vue?vue&type=template&id=a541a950&scoped=true", function () {
      api.rerender('a541a950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarExtraFieldsBlock.vue"
export default component.exports